<template>
    <div class="popUpHolder" v-if="isPopUpOpen" @click.self="isPopUpOpen = false">
        <div class="frame">
			<h1>Select Language</h1>
			<div class="languageWrap">
				<div class="enButton" @click.prevent="ChangeLanguage('en')">English</div>
				<div class="ruButton" @click.prevent="ChangeLanguage('ru')">Русский</div>
			</div>
        </div>
    </div>
</template>

<script>
export default {
	name: 'PopLanguage',
	data: () => ({
		isPopUpOpen: false,
		isMoreDetails: false,
		language: 'none',
		setImage: 0,
		setAlbum: 'none',
		setArray: ['none']
	}),
	methods: {
		ChangeLanguage(lang) {
		  this.$i18n.i18next.changeLanguage(lang);
		  this.language = lang;
		  this.$store.dispatch('SetLanguage',lang);
		  this.isPopUpOpen = false;
	},
	NewTabUrlOpen(val){
			alert(val)
			window.open(val, '_blank')
		}
	},
	created: function () {
		this.$root.$on('PopLanguageShow', () =>  {
			this.isPopUpOpen = true
		})        
	},
	mounted() {
		if (localStorage.W4MLanguage) {
			this.ChangeLanguage(localStorage.W4MLanguage);
		}
		else {
			this.isPopUpOpen = true;
		}
	},
	watch: {
		language(newLanguage) {
			localStorage.W4MLanguage = newLanguage;
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.enButton {
	width: 110px;
	height: 140px;
	background: url('./../img/en.svg') no-repeat center;
	background-size: 90%;
	padding-top: 125px;
	margin-top: -20px;
	font-weight: bold;
	color: black;
}
.enButton:hover {
	background-size: 100%;
	font-weight: bold;
	color: red;
}
.ruButton {
	width: 110px;
	height: 140px;
	background: url('./../img/ru.svg') no-repeat center;
	margin: 0px 10px;
	background-size: 90%;
	padding-top: 125px;
	margin-top: -20px;
	font-weight: bold;
	color: black;
}
.ruButton:hover {
	background-size: 100%;
	font-weight: bold;
	color: red;
}

.languageWrap {
	display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -ms-flex-direction: row;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    flex-direction: row;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -ms-flex-pack: justify;
    justify-content: center;
}
.popUpHolder {
    position: fixed;
    z-index: 500;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    padding: 0;
    background-color: rgba(0,0,0,0.7);    
}
.popUpHolder .frame {
    display:inline-block;
    margin-top: 5vh;   
    margin-left: auto;
    margin-right: auto;
    height: auto;
    min-width:50%;    
    width: auto;
    padding: 3px 3px 30px 3px;    
    background-color: rgba(255,255,255,0.9);
    box-shadow: 0 4px 2px -2px rgba(0,0,0,0.4);   
}
</style>



// WEBPACK FOOTER //
// src/components/PopLanguage.vue